import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '../../types/menu/MenuItem';
import SidebarItemLarge from '../../components/common/SidebarItemLarge/SidebarItemLarge';
import './Sidebar.css'
import { setNextActiveMenuItem, setPrevActiveMenuItem } from '../../redux/actions/menu/menu';
import { useNavigation } from '../../utils/context/NavigationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { selectMenu } from '../../redux/selectors/exportSelectorPaths';
import trackCustomGA4Event from '../../utils/GA4EventHelpers/trackCustomGA4Event';

interface SidebarProps {
    items: MenuItem[];
    collapsed: boolean;
    year: string;
    compareId: (a: number, b: number) => string;
    profileTypeCode?: string;
}

export interface SidebarItemProps {
    item: MenuItem;
    activeItemId: number;
    isChildActive?: (item: MenuItem, activeItemId: number) => boolean;
    index?: number;
    menuOnClick: (item: MenuItem) => void;
}

function Sidebar(props: SidebarProps) {
    const dispatch = useDispatch();
    const menuState = useSelector(selectMenu);
    const { setDirection } = useNavigation();
    const { t } = useTranslation("navigation");
    const activeCampaignYear = sessionStorage.getItem("activeCampaignYear");

    const menuOnClick = (menuItem: MenuItem) => {
        if (props.compareId(menuItem.id, menuState.activeItem.id) === "larger") {
            dispatch(setNextActiveMenuItem(menuItem))
            setDirection('forward');
        }
        else if (props.compareId(menuItem.id, menuState.activeItem.id) === "smaller") {
            dispatch(setPrevActiveMenuItem(menuItem))
            setDirection('backward')
        }
    }
    return (
        <div className={`sidebar-raw-root`}>
            {!props.collapsed && (
                <div className="sidebar">
                    <div className='sidebar-main-section'>
                        <h1 className='sidebar-year'>
                            {props.profileTypeCode === "AGS" ? t("aggregateTitle") : t("air")}
                        </h1>
                        {activeCampaignYear && (
                            <div className='sidebar-income-year'>
                                {t("campaignYear")}: {activeCampaignYear}
                            </div>
                        )}
                        <div className='sidebar-item-container'>
                            {props.items && props.items.map(item => (
                                <SidebarItemLarge
                                    key={item.id}
                                    item={item}
                                    activeItemId={menuState.activeItem.id}
                                    menuOnClick={menuOnClick}
                                />
                            ))
                            }
                        </div>
                    </div>
                    <div className='sidebar-footer-container'>
                        <div className='sidebar-footer-info-container'>
                            <div className='sidebar-logo-image-container'>
                                <img src="/images/MPAC_logo_no_bg.png" alt="MPAC Logo" />
                            </div>
                            <div className='sidebar-mpac-info'>
                                <div className='sidebar-mpac-info-text'>
                                    <div>{t("copyright", { activeCampaignYear: process.env.REACT_APP_ACTIVE_CAMPAIGN_YEAR })} <br /> {t("mpac")}&nbsp;1.2.0</div>
                                    <a href='https://www.mpac.ca/en/AboutUs/Policies/PrivacyStatement' target='#' title='Opens a new window'>
                                        {t("privacy-policy")} <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='external-link-icon-img'
                                            onClick={() => {
                                                trackCustomGA4Event("external_link",
                                                    {
                                                        link: "privacy_policy"
                                                    });
                                            }} />
                                    </a>
                                    <a href='https://www.mpac.ca/en/Contact' target='#' title='Opens a new window'>
                                        {t("contact-us")} <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='external-link-icon-img'
                                            onClick={() => {
                                                trackCustomGA4Event("external_link",
                                                    {
                                                        link: "contact_us"
                                                    });
                                            }} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            )}
        </div>

    )
}

export default Sidebar
